export default __webpack_public_path__ + "49ae34d4cc6b98c00c69ab4c41de3e0c.woff";